import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { GroupsApiService } from '@core/services/groups-api.service';
import { ToastService } from '@shared/services/toast.service';
import { catchError, map, of, switchMap, tap } from 'rxjs';
import { updateCustomer, updateCustomerSuccess, updateCustomerFailure } from '../actions/update-customer.actions';
import { Group } from '@shared/models/group';
import { loadActivitiesSuccess } from '@features/activities/actions/load-activities.actions';
import { loadNextStepSuccess } from '@features/next-steps/actions/load-next-step.actions';

@Injectable()
export class UpdateCustomerEffects {
  constructor(
    private actions$: Actions,
    private groupsApiService: GroupsApiService,
    private toastService: ToastService,
  ) {}

  updateCustomer$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateCustomer),
      switchMap((action) => {
        return this.groupsApiService.update(action.group).pipe(
          switchMap((response: { data: Group }) => [
            updateCustomerSuccess({ group: response.data }),
            loadActivitiesSuccess({ activities: response.data.attributes.activities || [] }),
            loadNextStepSuccess({ nextStep: response.data.attributes.next_step }),
          ]),
          catchError((error) => {
            return of(updateCustomerFailure({ error, group: action.group }));
          }),
        );
      }),
    ),
  );

  updateCustomerSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(updateCustomerSuccess),
        tap(() => {
          this.toastService.showToast('success', `Successfully saved changes.`, 3000);
        }),
      ),
    { dispatch: false },
  );

  updateCustomerFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(updateCustomerFailure),
        tap(({ error }) => {
          const errorMessage =
            typeof error.error?.errors === 'string'
              ? error.error.errors
              : 'Failed to update customer. Please try again later.';
          this.toastService.showToast('error', errorMessage, 10000);
        }),
      ),
    { dispatch: false },
  );
}
